import { breakpoints } from "../styles/design-tokens";

export const MOBILE_MAX_WIDTH = breakpoints.tablet - 1;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${breakpoints.tablet}px)`;
